module.exports = __webpack_public_path__ + "static/media/mehdiPilehvarian.6b3f1d4e.jpg";